<template>
    <div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Название <span class="red-text">*</span>
            </div>
            <input type="text" class="cd-modal-text-input" v-model="name">
            <div class="form-alert-danger" v-show="showAlert === 'category_name'">
                Обязательное поле!
            </div>
        </div>
        <div class="ap-modal-title-medium">
            Название родительской категории:
        </div>
        <div class="ap-button-edit-category ap-modal-element" v-on:click="selectCategory">
            <SVGAdminEditRow class="ap-button-edit-category-svg"/>
            <div class="ap-button-edit-category-text">{{parentCategory.name}}</div>
        </div>
        <div class="modal-button" v-on:click="apply">
            {{buttonName}}
        </div>
    </div>
</template>

<script>
import {bus} from "../../../../vue_bus";
import ProductCategories from "../ProductsPage/ProductCategories";
import SVGAdminEditRow from "../../../SVG/SVGAdminEditRow";

export default {
    name: "DataEntryForCategory",
    components: {SVGAdminEditRow},
    data(){
      return {
          name: '',
          selected: '',
          categories: [],
          parentCategory: {},
          necessaryFields: [
              'category_name'
          ],
          showAlert: ''
      }
    },
    props:{
      buttonName: {
          type: String
      },
        dataCategory:{
          type: Object,
            default(){
              return {};
            }
        },
        idSelectedCategory: {
            type: Number,
            default: null
        },
        parentHierarchyIds:{
            type: Array,
            default() {
                return [];
            }
        }
    },
    computed: {
      //   categoryList() {
      //     let categoryList = [{id: null, name: 'Корневой каталог'}];
      //     const categories = this.$store.getters["adminPanel/categories/SELF"];
      //
      //     const parser = (objectWithCategories) => {
      //         for(let idCategory in objectWithCategories){
      //             const category = objectWithCategories[idCategory];
      //             categoryList.push({id: category.id, name: category.name});
      //             if(Object.keys(category.subcategories).length !== 0){
      //                 parser(category.subcategories);
      //             }
      //         }
      //     }
      //
      //     parser(categories);
      //     return categoryList;
      // },
    },
    methods: {
        getCategory(hierarchyIds){
            if(hierarchyIds.length !== 0) {
                return this.$store.getters["adminPanel/categories/CATEGORY_BY_HIERARCHY_IDS"](hierarchyIds);
            } else {
                return {id: null, name: 'Корневой каталог'};
            }
        },
        selectCategory(){
            const beforeOpen = (event) => {
                bus.$on('productCategorySelected', (ids) => {
                    this.parentCategory = this.getCategory(ids);
                    this.$modal.hide('product-categories');
                });
            };
            const beforeClose = (event) => {
                bus.$off('productCategorySelected');
            };

            this.$modal.show(ProductCategories, {canChooseAny: true}, {
                    height: '70%',
                    pivotY: 0.4,
                    width: 450,
                    draggable: true,
                    name: 'product-categories',
                },
                {
                    'before-open': beforeOpen,
                    'before-close': beforeClose
                });
        },
        checkNecessary(data) {
            for (let field in this.necessaryFields) {
                console.log(field, data)
                if (!data[this.necessaryFields[field]]) {
                    console.log(this.necessaryFields[field])
                    return this.necessaryFields[field]
                }
            }
            return true
        },
        apply() {
            let data = {
                category_name: this.name,
                parent_id: this.parentCategory.id
            }
            let checkResult = this.checkNecessary(data)
            if (checkResult === true) {
                this.$emit("apply", data);
            } else {
                this.showAlert = checkResult
            }
        }
    },
    mounted() {
        this.parentCategory = this.getCategory(this.parentHierarchyIds);
        if (Object.keys(this.dataCategory).length !== 0) {
            this.name = this.dataCategory.name;
            this.selected = this.dataCategory.parent;
        } else {
            this.selected = this.idSelectedCategory;
        }
    }
}
</script>

<style scoped>

</style>
